<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="estimated_distance">Distanza Stimata</label>
                    <input
                        class="form-control"
                        ref="estimatedDistance"
                        id="estimated_distance"
                        :value="distanceFormatted()"
                        readonly
                    />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="estimated_time">Tempo Medio</label>
                    <input
                        class="form-control"
                        ref="estimatedTime"
                        id="estimated_time"
                        :value="timeEstimateFormatted"
                        readonly
                    />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="estimated_price">Prezzo Stimato</label>
                    <input
                        class="form-control"
                        ref="estimatedPrice"
                        id="estimated_price"
                        :value="priceFormatted()"
                        readonly
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <div v-if="!readOnly">
                        <label for="distance"
                            >Distanza<span class="form-required">*</span></label
                        >
                        <div class="form-wrap">
                            <div class="input-group">
                                <input
                                    type="number"
                                    step=".01"
                                    min="0"
                                    class="form-control"
                                    id="distance"
                                    name="distance"
                                    :value="distance"
                                    required
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text">Km</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <label for="distance">Distanza</label>
                        <input
                            class="form-control"
                            ref="distance"
                            id="distance"
                            :value="readOnlyDistance"
                            readonly
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="time_optimistic">Tempo Migliore</label>
                    <input
                        class="form-control"
                        ref="time_optimistic"
                        id="time_optimistic"
                        :value="timeOptimisticFormatted"
                        readonly
                    />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <div v-if="!readOnly">
                        <label for="price"
                            >Prezzo Minimo<span class="form-required"
                                >*</span
                            ></label
                        >
                        <div class="form-wrap">
                            <div class="input-group">
                                <input
                                    type="number"
                                    step=".01"
                                    min="0"
                                    class="form-control"
                                    id="price"
                                    name="price"
                                    :value="price"
                                    required
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text">€</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <label for="price">Prezzo Minimo</label>
                        <input
                            class="form-control"
                            ref="price"
                            id="price"
                            :value="readOnlyPrice"
                            readonly
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <br />
                <span class="small"
                    >Il prezzo stimato non include l'avvicinamento del
                    taxi</span
                ><br />
                <span class="small"
                    >I valori stimati sono calcolati in real-time</span
                >
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="time_pessimistic">Tempo Peggiore</label>
                    <input
                        class="form-control"
                        ref="time_pessimistic"
                        id="time_pessimistic"
                        :value="timePessimisticFormatted"
                        readonly
                    />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <div v-if="!readOnly">
                        <label for="price_max"
                            >Prezzo Massimo<span class="form-required"
                                >*</span
                            ></label
                        >
                        <div class="form-wrap">
                            <div class="input-group">
                                <input
                                    type="number"
                                    step=".01"
                                    min="0"
                                    class="form-control"
                                    id="price_max"
                                    name="price_max"
                                    :value="price_max"
                                />
                                <div class="input-group-append">
                                    <span class="input-group-text">€</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <label for="price_max">Prezzo Massimo</label>
                        <input
                            class="form-control"
                            ref="price_max"
                            id="price_max"
                            :value="readOnlyPriceMax"
                            readonly
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        time_estimate: null,
        time_optimistic: null,
        time_pessimistic: null,
        time: null,
        distance_estimate: null,
        distance: null,
        price_estimate: null,
        price: null,
        price_max: null
    }),
    props: {
        mapRef: {
            type: String,
            default: "map",
            required: false
        },
        route: {
            type: Object,
            default: null,
            required: false
        },
        readOnly: {
            type: Boolean,
            default: false,
            required: false
        },
        coeff: {
            type: Number,
            default: 1,
            required: false
        },
        base: {
            type: Number,
            default: 0,
            required: false
        }
    },
    computed: {
        readOnlyDistance: function() {
            return this.distance !== null
                ? this.distance.toFixed(2) + " Km"
                : "";
        },
        readOnlyTime: function() {
            return this.time !== null ? this.time + " min" : "";
        },
        readOnlyPrice: function() {
            return this.price !== null
                ? Intl.NumberFormat("it-IT", {
                      style: "currency",
                      currency: "EUR"
                  }).format(this.price)
                : "";
        },
        readOnlyPriceMax: function() {
            return this.price_max !== null
                ? Intl.NumberFormat("it-IT", {
                      style: "currency",
                      currency: "EUR"
                  }).format(this.price_max)
                : "";
        },
        timeEstimateFormatted: function() {
            return this.time_estimate ? this.time_estimate + " min" : "...";
        },
        timeOptimisticFormatted: function() {
            return this.time_optimistic ? this.time_optimistic + " min" : "...";
        },
        timePessimisticFormatted: function() {
            return this.time_pessimistic
                ? this.time_pessimistic + " min"
                : "...";
        }
    },
    methods: {
        setDetails: function(fieldDistance) {
            this.distance_estimate = (fieldDistance / 1000).toFixed(2);
            if (!this.distance) this.distance = this.distance_estimate;
            //formula
            let price_estimate =
                this.base + this.coeff * this.distance_estimate;
            this.price_estimate = parseFloat(price_estimate).toFixed(2);
            if (!this.price) this.price = this.price_estimate;
        },
        setTimeEstimate: function(fieldTime) {
            this.time_estimate = Math.round(fieldTime / 60);
            //if (!this.time) this.time = this.time_estimate;
        },
        setTimeOptimistic: function(fieldTime) {
            this.time_optimistic = Math.round(fieldTime / 60);
        },
        setTimePessimistic: function(fieldTime) {
            this.time_pessimistic = Math.round(fieldTime / 60);
        },
        timeFormatted: function() {
            return !!this.time_estimate ? this.time_estimate + " min" : "...";
        },
        distanceFormatted: function() {
            return !!this.distance_estimate
                ? this.distance_estimate + " Km"
                : "...";
        },
        priceFormatted: function() {
            return !!this.price_estimate ? this.price_estimate + " €" : "...";
        }
    },
    created: function() {
        if (!!this.route) {
            this.distance = this.route.distance;
            this.price = this.route.price;
            this.time = this.route.time_int;
            this.price_max = this.route.price_max;
        }
    }
};
</script>
